// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Page from "./homepage/Page";
import LoginForm from "./homepage/Admin";
import Dashboarddetails from "./homepage/dashboard";
import Socialdetailspost from "./homepage/ConnectionDomainAdd/Facebookpost";
import BussiessConcepted from "./homepage/BussinessManagementcomponents/AddbussinessManagement";
import Managecustomer from "./homepage/BussinessManagementcomponents/BussinessManagement";
import Pagecontent from "./homepage/SubmenuDetails/page";
import CostomerConnection from "./homepage/customeradddetails/suportingdetails";
import CustomerProfilepage from "./homepage/customeradddetails/profilepage";
import Customerdetailspage from "./homepage/customeradddetails/customermanagementdetails";
import TaskTracking from "./homepage/customeradddetails/Tasktraking";
import QuestionPage from "./homepage/customeradddetails/Questionpage";
import SuportingTickettrackingsystem from "./homepage/customeradddetails/Ticketmanagement";
import DeveloperPage from "./homepage/DeveloperContent/Developerpage";
import NotFoundPage from "./homepage/pagenotfound";
import ProfileManagement from "./homepage/developerpage/profiemanagement";
import Developer_Projectmanagment from "./homepage/developerpage/developerprojectmanagment";
import Attentenacemanagement from "./homepage/developerpage/Attentenacemanagement";
import AttendanceDashboard from "./homepage/AdminControlPage/Attendencesmanagement";
import AttendanceManagement from "./homepage/AdminControlPage/Projectmanagemet";
import AddProjrctdetails from "./homepage/ProjectManagement/AddProjrctdetails";
import DeveloperFileMethod from "./homepage/developerpage/DeveloperFileMethod";
import TaskManagement from "./homepage/Taskmanagement/TaskManagement";
import DevelopertaskDetails from "./homepage/developerpage/Developertask";
import Messsage_ConetentDetails from "./homepage/Messagecontent/Messagedetails";
import NewHomepage from "./homepage/NewHomepage";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMaQgyb2pcsASriyIes6n1n7oYjM02GVU",
  authDomain: "mithhomeconnect.firebaseapp.com",
  projectId: "mithhomeconnect",
  storageBucket: "mithhomeconnect.firebasestorage.app",
  messagingSenderId: "135193128281",
  appId: "1:135193128281:web:2508f95af792e6b2b0f048",
  measurementId: "G-LPQGF6BVVW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/home" element={<NewHomepage />} />
        {/* <Route path="/home" element={<NewHomepage />} /> */}
        <Route path="/adminlogin" element={<LoginForm />} />
        <Route path="/admin/dashboard" element={<Dashboarddetails />} />
        <Route path="/admin/Customerpost" element={<Messsage_ConetentDetails />} />
        <Route path="/admin/SocialPost" element={<Socialdetailspost />} />
        <Route path="/admin/ManageCustomers" element={<Managecustomer />} />
        <Route path="/admin/usermanagement" element={<BussiessConcepted />} />
        <Route path="/admin/Submenudetails" element={<Pagecontent />} />
        <Route path="/admin/developer" element={<DeveloperPage />} />
        <Route path="/admin/attendance" element={<AttendanceManagement />} />
        <Route path="/admin/taskmanagement" element={<TaskManagement />} />

        <Route path="/admin/adddetailspage" element={<Customerdetailspage />} />
        <Route path="/customer/dashboard" element={<CostomerConnection />} />
        <Route path="/customer/profileandaccount" element={<CustomerProfilepage />} />
        <Route path="/customer/projectmanagement" element={<CostomerConnection />} />
        <Route path="/customer/tasktracking" element={<TaskTracking />} />
        <Route path="/customer/billinginvoices" element={<CostomerConnection />} />
        <Route path="/customer/quotationsproposals" element={<QuestionPage />} />
        <Route path="/customer/ticketSystem" element={<SuportingTickettrackingsystem />} />
        <Route path="/customer/documentsandresources" element={<CostomerConnection />} />
        <Route path="/customer/feedbackreviews" element={<CostomerConnection />} />

        {/* developerpage contents */}
        <Route path="/developer/dashboard" element={<Dashboarddetails/>} />
        <Route path="/developer/developerprofile" element={<ProfileManagement/>} />
        <Route path="/developer/ProgjectManagement" element={<Developer_Projectmanagment/>} />
        <Route path="/developer/filetransfers" element={<DeveloperFileMethod/>} />
        <Route path="/developer/attendance" element={<Attentenacemanagement/>} />
        <Route path="/developer/Profileview" element={<AttendanceDashboard/>} />
        <Route path="/admin/project_management" element={<AddProjrctdetails/>} />
        <Route path="/developer/tasktraking" element={<DevelopertaskDetails/>} />
        {/* <Route path="" element={<Dashboarddetails/>} />
        <Route path="" element={<Dashboarddetails/>} /> */}



{/* Page not found */}

        <Route path="*" element={<NotFoundPage/>} />


     </Routes>
    </Router>
  );
}

export default App;
